import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { Result } from 'antd';

function reloadPage() {
    window.location.reload();
}

type Props = {
    /** Defaults to a full page reload; replaceable for tests. */
    onReload?: () => void;
};

/**
 * Shown when a route's code stopped arriving (`RouteChunkStallError`). Only a page load issues a
 * fresh request: retrying the route would wait on the same unanswered import. Rendered by
 * `ErrorFallback` (`AppProvider`'s boundary, inside the app's providers), and by the root route's
 * error component as a fallback.
 */
export function RouteChunkStallView({ onReload = reloadPage }: Props) {
    return (
        <div className="fixed inset-0 flex items-center justify-center">
            <Result
                className="max-w-(--breakpoint-sm)"
                status="warning"
                title="This page is taking too long to load"
                subTitle="Part of the app has not arrived. Reloading the page usually fixes this."
                extra={[
                    <Button key="reload" type="primary" onClick={onReload}>
                        Reload page
                    </Button>,
                ]}
            />
        </div>
    );
}
